import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DocentesService {
  API_URL = environment.apiURL + 'entradas';

  constructor(private http: HttpClient) { }
  getAllDocentes(): Observable<any>{
    return this.http.get<any[]>(this.API_URL);
  }
}
